export { default } from "./ScaleQuestionCard"